module.exports = __webpack_public_path__ + "img/ewm-wechat-miniapp.9114231c.jpg";